import { graphql } from 'react-relay';

import { commit } from './commit';

const mutation = graphql`
  mutation deleteCategoryMutation($input: DeleteCategoryInput!) {
    deleteCategory(input: $input) {
      destroyedCategoryId
      lists {
        ...CategoryList_lists
      }
    }
  }
`;

const deleteCategory = (environment, categoryId, listsId, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: {
        id: categoryId,
      },
    },
    configs: [
      {
        type: 'RANGE_DELETE',
        parentID: listsId,
        connectionKeys: [{ key: 'CategoryList_categories' }],
        pathToConnection: ['lists', 'categories'],
        deletedIDFieldName: 'destroyedCategoryId',
      },
    ],
    ...args,
  });
};

export default deleteCategory;
